export default __webpack_public_path__ + "static/media/img_tomcat-colorBkg.a60d763f.png";